<script lang="ts">
export default {
  name: 'Mail PDF',
  inheritAttrs: false,
  customOptions: {}
}
</script>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useGlobalStore } from '../stores/global';
  import { getReCaptchaToken } from '../js/get_recaptcha_token';

  const props = defineProps({
    post_url: { type: String, required: true },
    trans: { type: Object, required: true },
  });

  const store = useGlobalStore();

  let email = ref(store.user.email);
  let firstName = ref(store.user.firstName);
  let lastName = ref(store.user.lastName);

  let saving = ref(false);
  let mail_sent = ref(false);
  let mail_error = ref(false);
  let msg = ref('');

  const sendEmail = async () => {
    if (!email.value || !firstName.value || !lastName.value || saving.value) {
      return;
    }
    saving.value = true;
    mail_sent.value = false;
    mail_error.value = false;
    msg.value = '';

    try {
      const token = await getReCaptchaToken('send_franchise_pdf');

      const res = await fetch(props.post_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'g-recaptcha-response': token,
          email: email.value,
          firstName: firstName.value,
          lastName: lastName.value,
        }),
      });

      if (!res.ok) {
        throw new Error('Failed to send email');
      }

      const data = await res.json();
      if (!data.success) {
        mail_error.value = true;
        throw new Error(data.message || 'Failed to send email');
      }
      mail_sent.value = true;
      msg.value = data.message || 'Email sent successfully';
    } catch (error: any) {
      msg.value = error.message || 'An error occurred while sending the email';
      mail_error.value = true;
    } finally {
      saving.value = false;
    }
  };
</script>

<template>
  <div class="form" v-if="!mail_sent">
    <div class="row">
      <div>
        <label for="share-pdf-email">{{ trans.email }}</label>
        <input v-model="email" id="share-pdf-email" type="email" placeholder="" name="email" required>
      </div>
    </div>

    <div class="row">
      <div class="size-md">
        <label for="share-pdf-first-n ame">{{ trans.first_name }}</label>
        <input v-model="firstName" id="share-pdf-first-name" type="text" placeholder="" name="firstName" required>
      </div>
      <div>
        <label for="share-pdf-last-name">{{ trans.last_name }}</label>
        <input v-model="lastName" id="share-pdf-last-name" type="text" placeholder="" name="lastName" required>
      </div>
    </div>

    <div class="notice notice-error" v-if="mail_error" v-html="msg"></div>

    <div class="form-controls">
      <span></span>

      <button :disabled="saving" @click.prevent="sendEmail" class="btn-solid icon-rarr" :class="saving ? 'icon-spinner' : 'icon-mail'">
        {{ trans.send }}
      </button>
    </div>
  </div>

  <div v-else class="form">
    <div class="notice notice-success" v-html="msg"></div>
  </div>
</template>